/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocks_Hero_TitleInputs */

const en_stocks_hero_title = /** @type {(inputs: Stocks_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stocks`)
};

const de_stocks_hero_title = /** @type {(inputs: Stocks_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktien`)
};

const pt_br2_stocks_hero_title = /** @type {(inputs: Stocks_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ações`)
};

const tr_stocks_hero_title = /** @type {(inputs: Stocks_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hisseler`)
};

const zh_cn2_stocks_hero_title = /** @type {(inputs: Stocks_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`股票`)
};

const zh_hk2_stocks_hero_title = /** @type {(inputs: Stocks_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`股票`)
};

const ko_kr2_stocks_hero_title = /** @type {(inputs: Stocks_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주식`)
};

const ru_ru2_stocks_hero_title = /** @type {(inputs: Stocks_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Акции`)
};

const es_419_stocks_hero_title = /** @type {(inputs: Stocks_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acciones`)
};

/**
* | output |
* | --- |
* | "Stocks" |
*
* @param {Stocks_Hero_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const stocks_hero_title = /** @type {((inputs?: Stocks_Hero_TitleInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocks_Hero_TitleInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_stocks_hero_title(inputs)
	if (locale === "de") return de_stocks_hero_title(inputs)
	if (locale === "pt-BR") return pt_br2_stocks_hero_title(inputs)
	if (locale === "tr") return tr_stocks_hero_title(inputs)
	if (locale === "zh-CN") return zh_cn2_stocks_hero_title(inputs)
	if (locale === "zh-HK") return zh_hk2_stocks_hero_title(inputs)
	if (locale === "ko-KR") return ko_kr2_stocks_hero_title(inputs)
	if (locale === "ru-RU") return ru_ru2_stocks_hero_title(inputs)
	return es_419_stocks_hero_title(inputs)
});